import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import logo from 'images/logo-sanlam.png';
import { PAGES } from 'routes';

export interface SahamLogoProps {
  width?: string;
  height?: string;
  isManager?: boolean;
}

const SahamLogo: FunctionComponent<SahamLogoProps> = (props): JSX.Element => {
  return (
    <div className="logo logo--appbar">
      <Link to={props.isManager ? PAGES.MANAGER_HOME : PAGES.LAWYER_HOME}>
        <img
          width={props.width}
          height={props.height}
          src={logo}
          alt="Sanlam"
        />
      </Link>
    </div>
  );
};

SahamLogo.defaultProps = {
  isManager: false,
};

export default SahamLogo;
